import React, { useEffect, useRef } from 'react';
import {
  disableBodyScroll,
  clearAllBodyScrollLocks,
  enableBodyScroll,
} from 'body-scroll-lock';

import styled from '@emotion/styled';

function BaseModal({ children, isOpen, contentStyle }) {
  const ModalRef = useRef(null);
  useEffect(() => {
    if (ModalRef.current) {
      if (isOpen) {
        disableBodyScroll(ModalRef.current);
      } else {
        enableBodyScroll(ModalRef.current);
      }
    }
    return () => {
      clearAllBodyScrollLocks();
    };
  }, [isOpen, ModalRef]);

  return (
    <ModalContainer ref={ModalRef} className="modal" id="modal">
      <div className="modal-content" style={contentStyle}>
        {children}
      </div>
    </ModalContainer>
  );
}

export default BaseModal;

const ModalContainer = styled.div`
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(
    0,
    0,
    0,
    0.4
  ); /* Overlay effect: translucent background: black w/ partial opacity */
  z-index: 10000; /* Overlay effect: positioned over other containers */
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  position: fixed; /* Fix position on the top-left corner*/
  top: 0;
  left: 0;
  overflow: auto; /* Enable scroll if needed */
  /* Modal content */
  .modal-content {
    position: relative;
    background-color: white;
    width: 100%; /* Width in proportion to its parent container*/
    max-width: 640px; /* Max width where it stops expanding */
    height: 100%; /* Height in proportion to its parent container */
    margin: auto; /* Auto margin according to the element width */
  }
`;
